export const seriesConfig: () => any = () => [
  {
    name: 'Market Cap',
    type: 'line',
    turboThreshold: 0,
    dataLabels: {
      inside: true,
    },
    yAxis: 0,
    cursor: 'pointer',
    color: '#84C47C',
    shadow: false,
    dataGrouping: {
      enabled: true,
      groupPixelWidth: 1,
    },
  },
  {
    name: 'Volume',
    type: 'column',
    turboThreshold: 0,
    dataLabels: {
      inside: true,
    },
    cursor: 'pointer',
    color: '#777777',
    yAxis: 1,
    pointPadding: 0,
    groupPadding: 0,
    borderWidth: 0,
    shadow: false,
    dataGrouping: {
      enabled: true,
      groupPixelWidth: 1,
    },
  },
]

export const yAxisConfig: () => any = () => [
  {
    title: {
      text: 'Market Cap',
      style: {
        color: '#84c47c',
      },
    },
    showFirstLabel: true,
    showLastLabel: false,
    startOnTick: true,
    endOnTick: true,
    lineColor: 'rgba(255, 255, 255, 0.2)',
    lineWidth: 0,
    gridLineColor: 'rgba(255, 255, 255, 0.2)',
    opposite: false,
    labels: {
      y: -25,
      useHTML: true,
      reserveSpace: true,
      overflow: 'allow',
    },
    height: '80%',
    maxPadding: 0.5,
  },
  {
    allowDecimals: true,
    scalable: false,
    title: {
      text: '24h Vol',
      style: {
        color: '#777',
      },
    },
    showFirstLabel: true,
    showLastLabel: false,
    startOnTick: true,
    endOnTick: false,
    lineColor: 'transparent',
    lineWidth: 0,
    gridLineColor: 'rgba(255, 255, 255, 0.2)',
    labels: {
      y: -25,
      useHTML: true,
      reserveSpace: true,
      overflow: 'allow',
    },
    opposite: false,
    height: '27.5%',
    top: '72.5%',
  },
]
